
export enum ITrackingEventCategory{
    MEETING = 'MEETING',
    DOCUMENT = 'DOCUMENT'
}

export interface ITrackingEventActor{
    uid: string,
    name: string,
    type: string
}

export enum ITrackingEventName{
    CUSTOMER_ADDED = "CUSTOMER_ADDED",
    CONTENT_SHARED = "CONTENT_SHARED",
    CONTENT_PAGE_ACCESSED = "CONTENT_PAGE_ACCESSED",
    MEETING_SCHEDULED = "MEETING_SCHEDULED",
    MEETING_STARTED = "MEETING_STARTED",
    MEETING_ENDED = "MEETING_ENDED",
    CUSTOMER_JOINED = "CUSTOMER_JOINED",
    CUSTOMER_EXITED = "CUSTOMER_EXITED",
    SLIDE_CHANGED = "SLIDE_CHANGED",

    ORIENTATION_CHANGED = "ORIENTATION_CHANGED",
}

export interface IEventGeo{
    lat?: string,
    lng?: string
}

export interface IEventDeviceInfo{
    isBrowser?: boolean,
    isMobile?: boolean,
    isTablet?: boolean,
    isSmartTV?: boolean,
    isConsole?: boolean,
    isWearable?: boolean,
    isMobileSafari?: boolean,
    isChromium?: boolean,
    isMobileOnly?: boolean,
    isAndroid?: boolean,
    isWinPhone?: boolean,
    isIOS?: boolean,
    isChrome?: boolean,
    isFirefox?: boolean,
    isSafari?: boolean,
    isOpera?: boolean,
    isIE?: boolean,
    isEdge?: boolean,
    isYandex?: boolean,
    osVersion?: string,
    osName?: string,
    fullBrowserVersion?: string,
    browserVersion?: string,
    browserName?: string,
    mobileVendor?: string,
    mobileModel?: string,
    engineName?: string,
    engineVersion?: string,
    getUA?: string,
    deviceType?: string,
    screenWidth?: number,
    screenHeight?: number,
}

export default interface ITrackingEvent {
    eventCategory: ITrackingEventCategory,
    eventName: ITrackingEventName,
    attributes: any,
    deviceInfo: IEventDeviceInfo,
    geoInfo: IEventGeo,
    actor: ITrackingEventActor,
    timestamp: Date,
    correlationId?: string
}